import { render, staticRenderFns } from "./SourceTabs.vue?vue&type=template&id=5a7b32d2&"
import script from "./SourceTabs.vue?vue&type=script&lang=js&"
export * from "./SourceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports